import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Tooltip } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';

import { StyledTitle } from 'components/StyledTitle';
import ClaimSettlementNoticeTable from './ClaimSettlementNoticeTable';

import { ClaimSettlementNoticeTableDataType } from 'pages/documents/types/documentsTypes';

const ClaimSettlementNoticeContainer = styled.div`
  margin-top: 56px;
`;

const ClaimSettlementNoticeHeader = styled.div`
  display: flex;
  margin-bottom: 16px;
`;

interface ClaimSettlementNoticeProp {
  claimSettlementNotices: ClaimSettlementNoticeTableDataType[];
}

function ClaimSettlementNotice({ claimSettlementNotices }: ClaimSettlementNoticeProp) {
  const { t } = useTranslation();
  return (
    <ClaimSettlementNoticeContainer>
      <ClaimSettlementNoticeHeader>
        <StyledTitle level={5} margin="0 4px 0 0">
          {t('documents.claimSettlementNotice')}
        </StyledTitle>
        <Tooltip placement="top" title={t('documents.claimSettlementNoticeHeaderTooltip')}>
          <QuestionCircleOutlined style={{ margin: 'auto 0' }} />
        </Tooltip>
      </ClaimSettlementNoticeHeader>
      <ClaimSettlementNoticeTable data={claimSettlementNotices} />
    </ClaimSettlementNoticeContainer>
  );
}

export default ClaimSettlementNotice;
